<div>
  <p
    class="m-0"
    [innerHTML]="createdByMessage"
  ></p>
  <p>{{ 'contractRegeneration.uploadOrGenerate' | translate }}</p>
  <p>{{ 'contractRegeneration.warning' | translate }}</p>
</div>

<base-contract-upload
  (enableContractUpload)="enableContractUpload($event)"
  (uploadContract)="setUploadedContractFile($event)"
></base-contract-upload>

<div
  class="collapsable-content mt-2 py-2"
  [ngClass]="{ 'is-collapsed': !isShowContractPreview }"
>
  <div
    class="collapsable-header arrow-start mb-0 p-3"
    (click)="toggleContractPreview()"
  >
    <div>{{ 'contractRegeneration.contractPreviewMessage' | translate }}</div>
  </div>
  <div class="collapsable-body bg-lightest px-2">
    <iframe
      id="embedded"
      [src]="sanitizedSrc"
      class="w-100 vh-100"
    ></iframe>
  </div>
</div>
<div class="modal-footer px-0 py-3 w-100">
  <base-button
    class="me-3"
    color="secondary"
    label="action.cancel"
    [size]="buttonSizes.md"
    (btnClick)="closeModal()"
  ></base-button>
  <base-button
    color="primary"
    [disabled]="isContractUploadEnabled && !uploadedContractFile"
    [size]="buttonSizes.md"
    [label]="
      isContractUploadEnabled
        ? 'contractRegeneration.uploadOwnContract.confirmButtonText'
        : 'contractRegeneration.regenerateActionText'
    "
    (btnClick)="updateContract()"
  ></base-button>
</div>
